import React from 'react';
import PropTypes from 'prop-types';

import {Box, Button, Typography} from 'views/components';
import {ArrowForward} from 'views/icons';
import {Translate} from 'views/module';

const TourGuide = (props) => {
  const {stepIndex, title, description, onNext, onSkip, mobile} = props;

  const totalSteps = mobile ? 5 : 4;

  return (
    <Box
      sx={{
        width: '320px',
        padding: '16px',
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        border: '1px solid #e5e7eb',
        position: 'relative',
        fontFamily: 'sans-serif',
      }}
    >

      {/* Progress Bar */}
      <Box
        sx={{
          display: 'flex',
          gap: '4px',
          marginBottom: '12px',
        }}
      >
        {
          Array.from({length: totalSteps}).map((_, index) => (
            <Box
              key={index}
              sx={{
                height: '4px',
                flex: 1,
                borderRadius: '9999px',
                backgroundColor: index <= stepIndex ? '#f97316' : '#e5e7eb',
              }}
            />
          ))
        }
      </Box>

      {/* Title */}
      <h2
        style={{
          fontSize: '16px',
          fontWeight: 600,
          color: '#111827',
          marginBottom: '2px',
        }}
      >
        {title}
      </h2>

      {/* Description */}
      <Typography
        sx={{
          fontSize: '14px',
          color: '#6b7280',
          marginBottom: '20px',
          lineHeight: '1.4',
          marginTop: '10px',
        }}
      >
        {description}
      </Typography>

      {/* Separator */}
      <Box
        sx={{
          height: '1px',
          backgroundColor: '#e5e7eb',
          margin: '16px 0',
        }}
      />

      {/* Bottom Row Buttons */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Button
          onClick={onSkip}
          sx={{
            fontSize: '14px',
            color: '#9ca3af',
            background: 'transparent',
            border: 'none',
            boxShadow: 'none',
            cursor: 'pointer',
            padding: 0,
            ['&:hover']: {
              background: 'transparent',
              color: '#9ca3af',
              boxShadow: 'none',
            },
          }}
        >
          <Translate expression="profile.TourGuide.Skip" />
        </Button>

        <Button
          onClick={onNext}
          sx={{
            backgroundColor: '#f97316',
            color: 'white',
            fontSize: '14px',
            padding: '6px 12px',
            borderRadius: '6px',
            border: 'none',
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <Translate expression="profile.TourGuide.Next" />
          <ArrowForward
            style={{
              marginLeft: '4px',
              height: '16px',
              width: '16px',
            }}
          />
        </Button>
      </Box>
    </Box>
  );
};

TourGuide.propTypes = {
  stepIndex: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onNext: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
  mobile: PropTypes.bool,
};

export default TourGuide;
